import { useState } from 'react';
import { marqueeItems, categoryNav } from '@/mocks/heiLiao';

function HotNav() {
  return (
    <nav className="flex items-center gap-1 overflow-x-auto no-scrollbar">
      {categoryNav.map((c) => (
        <a
          key={c}
          href="#expose-index"
          className="whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
        >
          {c}
        </a>
      ))}
    </nav>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* 品牌 */}
          <a href="#" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-base"></i>
            </span>
            <span className="font-heading text-lg leading-none tracking-wide text-foreground-950">
              最新黑料
            </span>
          </a>

          <div className="hidden flex-1 items-center justify-center md:flex">
            <HotNav />
          </div>

          {/* 右侧动作 */}
          <div className="flex items-center gap-2">
            <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100/70 py-1.5 pl-3 pr-2 lg:flex">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                className="w-32 bg-transparent text-[13px] text-foreground-800 outline-none placeholder:text-foreground-400"
                placeholder="搜主角 / 关键词"
              />
              <button className="whitespace-nowrap rounded-full bg-secondary-900 px-2.5 py-1 text-[11px] text-background-50 transition-colors hover:bg-secondary-700">
                追踪
              </button>
            </div>
            <span className="hidden items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-[12px] font-medium text-primary-700 sm:flex">
              <i className="ri-broadcast-line animate-blink text-[13px] text-primary-500"></i>
              LIVE 更新中
            </span>
            <button
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-background-200 text-foreground-700 md:hidden"
              aria-label="菜单"
            >
              <i className={open ? 'ri-close-line text-lg' : 'ri-menu-3-line text-lg'}></i>
            </button>
          </div>
        </div>

        {/* 移动菜单 */}
        {open && (
          <div className="border-t border-background-200/70 py-3 md:hidden">
            <HotNav />
          </div>
        )}
      </div>

      {/* 跑马灯快讯 */}
      <div className="border-t border-background-200/60 bg-background-50">
        <div className="mx-auto flex max-w-[1440px] items-center gap-3 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 rounded bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
            <i className="ri-flashlight-fill text-[11px]"></i> 速递
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-10">
              {[...marqueeItems, ...marqueeItems].map((m, idx) => (
                <span key={idx} className="whitespace-nowrap text-[12px] text-foreground-700">
                  {m}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}